<template>
  <div class="padding text-center">
    <div v-if="!slide.showYouTubeIframe && slide.youtubeLink">
      <p class="custom-mb-3">
        {{ $t("watchVideo") }}
      </p>
    </div>
    <div
      class="img-slide"
      v-if="slide.showYouTubeIframe && slide.youtubeLink"
    >
      <iframe
        v-if="id"
        class="youtube-iframe"
        width="668"
        height="375.75"
        :src="id"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      />
    </div>
    <div class="no-data" v-if="!slide.youtubeLink">
      <p class="custom-mb-3">
        {{ $t("blankSlide") }}
      </p>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Util from '@/util'

export default {
  data() {
    return {
      id: '',
    }
  },
  computed: {
    ...mapGetters({
      slide: 'activeActivity',
    }),
  },
  watch: {
    slide: function _() {
      this._getYouTubeLink()
    },
  },
  mounted() {
    this._getYouTubeLink()
  },
  methods: {
    _getYouTubeLink() {
      if (
        this.slide.youtubeLink &&
        Util.isURL(this.slide.youtubeLink)
      ) {
        const id = Util.getParamValue('v', this.slide.youtubeLink)
        if (id) {
          this.id = `https://www.youtube.com/embed/${id}`
        } else {
          const embedIndex = this.slide.youtubeLink.indexOf('/embed/')
          if (embedIndex != -1) {
            this.id = this.slide.youtubeLink
          } else {
            this.id = ''
          }
        }
      } else {
        this.id = ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.img-slide {
  position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    padding-top: 25px;
    height: 0;
  .youtube-iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
